<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>纸条列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-select size="small" v-model="formInline.isLock" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="已过审" value="1"></el-option>
          <el-option label="未过审" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userName" placeholder="输入纸条编号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userMobile" placeholder="输入用户编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="paperData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column align="center" prop="paperId" label="纸条编号" min-width="80">
      </el-table-column>
      <el-table-column align="center" prop="userId" label="放入用户" min-width="80">
      </el-table-column>
      <el-table-column align="center" prop="userIntroduce" label="自我介绍" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="userNeed" label="交友要求" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="userSex" label="性别" min-width="50">
      </el-table-column>
      <el-table-column align="center" prop="userCity" label="所在城市" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="userWx" label="微信号" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="userIp" label="ip" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="commitTime" label="放入时间" min-width="100">
        <template slot-scope="scope">
          <div>{{scope.row.commitTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="isOpen" label="是否过审" min-width="50">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isOpen===1?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="isDelete" label="是否删除" min-width="50">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isDelete===1?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {
  paperList,
  updateOpen
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
      // 选择数据
      selectdata: [],
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
        deptId: '',
        userName: '',
        userMobile: '',
        isLock: ''
      },
      //用户数据
      paperData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      paperList(parameter).then(res => {
        this.loading = false
        if (res.code == '00031') {
          this.paperData = res.data.list
          // 分页赋值
          this.formInline.page = this.pageparm.pageIndex
          this.formInline.limit = this.pageparm.pageSize
          this.pageparm.total = res.data.total
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageIndex = parm.pageIndex
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.pageparm)
    },
    //搜索事件
    search() {
      this.getdata(this.pageparm)
    },
    // 修改type
    editType: function(index, row) {
      this.loading = true
      let parm = {
        'paperId': row.paperId,
        'openStatus': row.isOpen
      }
      let openStatus = row.isOpen
      if (openStatus == 1) {
        parm.openStatus = 0
      } else {
        parm.openStatus = 1
      }
      // 修改状态
      updateOpen(parm).then(res => {
        this.loading = false
        if (res.code == '00041') {
          row.isOpen = parm.openStatus
          this.$message({
            type: 'success',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      return change
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/paper/paper.vue